module.exports = __webpack_public_path__ + "img/mockup-fratelli-home.ced9e52.png";